// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2227":"e2bc188aa1f446a2","2987":"df380b72895bcae4","5532":"09c520cfd7a73e93","8492":"d18616eced26cd62","8998":"b765792ae077f37c","9081":"6e165a25698327e1"}[chunkId] + ".js";
};